import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./assets/styles/App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import RoutesList from "./RoutesList";
import ScrollAgent from "./Helper/ScrollAgent";
import PopUp from "./components/PopUp/PopUp";
import PopUErgo from "./components/PopUp/PopUp_Ergo";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <RoutesList />
        <Footer />
        <ScrollAgent />
        <PopUErgo />
      </BrowserRouter>
    </div>
  );
}

export default App;
